import { render, staticRenderFns } from "./SubscribeButton.vue?vue&type=template&id=67e15ee6&scoped=true&"
import script from "./SubscribeButton.vue?vue&type=script&lang=js&"
export * from "./SubscribeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e15ee6",
  null
  
)

export default component.exports